export default function({ route, isDev }) {
	if (isDev) {
		console.log('router ' + route.path)
	}
}
